import { ValidationType } from '@enums';
import { createValidationSchema } from '@utils';

export const RECOVER_PASSWORD_SCHEMA = createValidationSchema({
  email: {
    required: true,
    pattern: ValidationType.EMAIL,
  },
});
